import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="camera"
export default class extends Controller {
  static targets = ["video"]

  connect() {
    this.startCamera()
    console.log("Camera controller connected");
  }

  disconnect() {
    this.stopCamera()
  }

  startCamera() {
    navigator.mediaDevices.getUserMedia({ video: true })
      .then(stream => {
        this.videoTarget.srcObject = stream
        this.videoTarget.play()
        // Mirror the video horizontally
        this.videoTarget.style.transform = "scaleX(-1)";
      })
      .catch(err => {
        console.error("Error accessing camera: ", err)
      })
  }

  stopCamera() {
    if (this.videoTarget.srcObject) {
      this.videoTarget.srcObject.getTracks().forEach(track => track.stop())
    }
  }
}
